<template>
    <div>
        <div class="white_container">
            <div class="page-header">
                <h1>{{$t("masterclass.LBL_PAGE_HEADER")}}</h1>
                <p v-html="$t('masterclass.LBL_PAGE_DESCRIPTION')"></p>
            </div>
        </div>
        <div class="white_container">
            <div class="page-header">
                <h1>{{$t("masterclass.LBL_REFERRAL_PAGE_TITLE")}}</h1>
                <div class="referral-link-wrapper">
                    <div class="link-wrapper">
                        <div class="field-wrapper">
                            <div class="input-wrapper">
                                <input type="text" disabled :value="link()"/>
                                <input class="hidden-input" ref="link" type="text" :value="link()"/>
                            </div>
                        </div>
                        <div class="button-wrapper">
                            <div class="button" @click="copyLink">
                                <span>{{$t('strings.BTN_CLIPBOARD')}}</span>
                            </div>
                            <transition name="tooltip-bounce">
                                <div v-show="tooltip_visible" class="tooltip">{{$t("masterclass.LBL_LINK_COPYIED")}}</div>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="referral-link-steps">
                    <div class="step">
                        <div class="step-title">1</div>
                        <p v-html="$t('masterclass.LBL_REFERRAL_STEP_1_DESCRIPTION')"></p>
                    </div>
                    <div class="step">
                        <div class="step-title">2</div>
                        <p v-html="$t('masterclass.LBL_REFERRAL_STEP_2_DESCRIPTION')"></p>
                    </div>
                    <div class="step">
                        <div class="step-title">3</div>
                        <p v-html="$t('masterclass.LBL_REFERRAL_STEP_3_DESCRIPTION')"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .page-header{
        text-align: center;
        padding: 6rem;
        h1{

        }
        p{
            margin-top: 1rem;
            color: rgba(11, 16, 34, 0.3);
        }
        .referral-link-wrapper{
            display: flex;
            align-items: center;
            justify-content: center;    
            margin-top: 3rem;
            position:relative;
            .link-wrapper{
                position: relative;    
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
            }
            .field-wrapper{
                margin-bottom: 0px;
                margin-right: 20px;
                .input-wrapper{
                    margin: 0px;
                    input{
                        margin: 0px;
                    }
                    .hidden-input{
                        position: absolute;
                        left: 0px;
                        right: 0px;
                        top: 0px;
                        bottom: 0px;
                        z-index: -1;
                        opacity:0;
                    }
                }
            }
        }
        .referral-link-steps{
            display: grid;
            grid-template-columns: repeat(3,1fr);
            grid-gap: 2rem;
            margin-top: 4rem;
            .step{    
                text-align: left;
                .step-title{
                    font-family: FuturaPT;
                    font-size: 48px;
                    line-height: 74px;
                    display: flex;
                    align-items: center;
                    color: #444444;
                    font-weight: bold;
                }
                p{
                    color:#545454;
                }
            }
        }
        .button-wrapper{
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
        .tooltip{
            align-items: center;
            padding: 0.95rem 2.21rem 1rem;
            position: relative;
            font-family: FuturaPT;
            letter-spacing: 0.05rem;
            font-size: 1rem;
            color: #0b1022;
            background: #fff;
            border-radius: 100px;
            box-shadow: 0px 2px 4px #c8c8c8;
            position: absolute;
            white-space: nowrap;
            z-index: 0;
            opacity:1;
            top:-50px;
        }
        .tooltip-bounce-enter-active {
            animation: tooltip-bounce-in .3s;
        }

        .tooltip-bounce-leave-active {
            animation: tooltip-bounce-in .3s reverse;
        }

        @keyframes tooltip-bounce-in {
            0% {
                transform: scale(0);
                opacity:0;
                top:0px;
            }
            50% {
                transform: scale(1.1);
                opacity:1;
                top:-50px;
            }
            100% {
                transform: scale(1);
            }
        }
    }
</style>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import store from '@/store';
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';
    import lStorage from '@/store/localStorage';
    import env from '@/enviroment';
    import ErrorPopup from "@/views/pages/manager_popups/ErrorPopup";

    export default {
        name:'Referral',
        components:{
        },
        data:function(){
            return{
                tooltip_visible:false
            }
        },
        methods:{
            copyLink(){
                this.$refs.link.select();
                document.execCommand("copy");
                this.tooltip_visible=true;
                setTimeout(()=>{
                    this.tooltip_visible = false;
                },1000);
            },
            link(){
                return window.location.origin+"/invite/"+this.user.id;
            }
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
            url_prefix(){
                return (i18n.locale=="ro"?"":"/"+i18n.locale);
            },
        },
    }
</script>